import { createApp } from 'vue'
import App from './App.vue'

// 引入Tailwind CSS
import './main.css'

// 引入Font Awesome
import 'font-awesome/css/font-awesome.min.css'

createApp(App).mount('#app')
